import styled from "styled-components";

export const MyHorizontalScrollView = styled.div`
	> input {
		width: 100%;
		min-height: 38px;
		padding: 2px 8px;
		border-color: hsl(0, 0%, 80%) !important;
		-moz-appearance: textfield;
		&::-webkit-inner-spin-button,
		&::-webkit-outer-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
		&:focus {
			box-shadow: none;
			border-color: #2684ff !important;
		}
	}
`;
//Almost all the things over here is for modal
export const MyModalBody = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 1rem;

	> h5 {
		font-weight: 350;
	}

	> label {
		color: var(--sidebar);
	}
`;

export const MyModalInput = styled.input`
	border-color: silver !important;
	padding: 0.4rem;
	width: 100%;
	margin-bottom: 1rem;
`;

export const MyModalTextArea = styled.textarea`
	border-color: silver !important;
	padding: 0.4rem;
	width: 100%;
	height: 85px;
	margin-bottom: 1rem;
	resize: none;
`;

export const ShowReject = styled.div`
	display: flex;
	padding: 0.3rem;
	align-items: center;
	flex-direction: row;
	> label {
		margin-left: 1rem;
		cursor: pointer;
	}
	> input[type="checkbox"] {
		margin-left: 0.7rem;
		width: 16px;
		height: 16px;
		cursor: pointer;
	}
`;

export const QuickyReplies = styled.div`
	> div {
		display: flex;
		align-items: center;
		> input {
			margin: 0 5px 0 0;
		}
		> button {
			margin: 0 2px;
		}
	}
`;

export const QuickyRepliesAction = styled.div`
	display: flex;
	align-items: center;

	> label {
		margin: 0;
	}
	> div {
		flex-grow: 1;
		margin: 0 0 0 5px;
	}
`;

export const DivisionBox = styled.div`
	border: 1px solid #ccc;
	padding: 8px;

	> .input-group {
		flex-direction: column;
		margin-bottom: 1rem;
	}

	&.btn-call-to-action {
		flex-direction: column;
		align-items: baseline;
	}
`;

export const DivisionTemplateType = styled.div`
	border: 1px dashed #ccc;
	padding: 5px;

	margin-bottom: 1rem;

	> span.error {
		display: block;
		margin: 1rem 0;
		color: #dc3545;
	}

	> div.quicky_replies_types {
		flex-direction: column;
		margin-bottom: 1rem;

		> button.remove-quicky-reply {
			width: fit-content;
			margin-left: auto;
			margin-bottom: 1rem;
		}
	}

	&.template-header {
		> span.template-header--filename {
			display: block;
			margin: 5px 0;
		}
		> span.template-header--obs {
			font-size: 12px;
			color: #999;
			display: block;
			margin: 5px 0;
		}
	}

	> div:not(.quicky_replies_types) {
		display: flex;
		align-items: center;
		height: 38px;

		> span {
			height: 100%;
			background-color: rgb(192, 204, 218);
			padding: 2px 5px;
			display: flex;
			align-items: center;
			border-radius: 4px;
			text-transform: uppercase;
		}

		> div {
			margin-left: 10px;
			width: 200px;
		}
	}

	> hr {
		margin: 10px 0;
	}
`;

export const DeleteFromApi = styled.div`
	margin-top: 20px;

	> div {
		display: flex;
		align-items: center;

		> input {
			margin-left: 5px;
		}
	}
	> span.warning {
		display: block;
		margin-top: 5px;
		text-decoration: underline;
		color: #c53f3f;
		font-size: 16px;
	}
`;
